import { UseDispatch } from 'react-redux'

import { Itinerary } from '@/travelsuit'
import { FlightProvider } from '@/types/flights/common'
import { FlightPolicyDeviation } from '@/types/flights/search'
import { SEAT_CHARACTERISTICS, SEAT_STATUSES, SeatMapInfoItem, SeatMapSeat } from '@/types/seatMap'

// eslint-disable-next-line no-restricted-syntax
export enum POSITIONS {
	// W - means window seat
	W = 'W',
	// A - means aisle seat
	A = 'A',
	// C - means center seat
	C = 'C',
	// WA/AW - means window on one side and aisle on the other side
	WA = 'WA',
	AW = 'AW',
	N = 'NONE',
}

// eslint-disable-next-line no-restricted-syntax
export enum ROW_CHARACTERISTICS {
	// Z - means row doesn't exist
	Z = 'Z',
	// E - means exit row
	E = 'E',
	// K - means overwing row
	K = 'K',
}

//* Seat map typings

export interface SeatMapColumn {
	index: string
	position: SeatMapInfoItem<POSITIONS>
}

export interface ManageItinerarySeatData {
	flight_segment_id: string
	description: null
	policy_deviations: FlightPolicyDeviation[]
	status: SeatMapInfoItem<SEAT_STATUSES>
	amount: number
	seat_key: string
	in_policy: boolean
	number: string
	traveler_id: number
	characteristics: SeatMapInfoItem<SEAT_CHARACTERISTICS>[]
	column: string
}

export interface SeatMapRow {
	characteristics: SeatMapInfoItem<ROW_CHARACTERISTICS>[] | null
	number: number | null
	seats: SeatMapSeat[] | null
}

export interface SeatMapDeck {
	cabin: SeatMapInfoItem
	columns: SeatMapColumn[]
	rows: SeatMapRow[]
	location: SeatMapInfoItem
	overwingRowNumbers: {
		first: number
		last: number
	}
	rowNumbers: {
		first: number
		last: number
	}
}

export interface SeatMapType {
	decks: SeatMapDeck[]
	errors: string[]
	segment: {
		segmentIdRef: number
	}
}

export interface ParsedSeatMap {
	decks: SeatMapDeck[] | null
	errors: string[] | null
	segmentIndex: number
}

export interface SeatMapParams {
	fare_group_key?: string
	flight_option_keys?: string[]
	users_id: (number | null)[]
	search_id?: number
	flight_identifier?: string
	booking_segment_id?: number
	vendor_key?: FlightProvider
}

export const INITIAL_SEAT_MAP_SET: SeatMapSeat = {
	amount: 0,
	converted_amount: 0,
	characteristics: [
		{
			code: SEAT_CHARACTERISTICS.L,
			description: 'Leg space',
		},
	],
	column: '',
	seatKey: '',
	status: {
		code: SEAT_STATUSES.A,
		description: 'Available',
	},
	number: '',
	in_policy: false,
	policyDeviations: [],
	airportLabel: '',
	segmentId: '',
	traveler_id: 0,
	travelerDetails: [],
	seat_key: '',
	flight_segment_id: '',
}

export const INITIAL_PARSED_SEATMAP: ParsedSeatMap = {
	decks: null,
	errors: null,
	segmentIndex: 0,
}

export interface ManageSeatParams {
	dispatch: ReturnType<UseDispatch>
	tripId: number
	isMultipleFlight: boolean
	selectedFlightId: number
	location: Pick<Location, 'reload'>
}

export interface getFilteredSelectedSeatsParams {
	itinerary: Itinerary
	noSelectedSeats: boolean
	selectedFlightId: number
}
